export enum PredefinedSkillType {
  Delivery = "Delivery",
  Merchandise = "Merchandise",
  Order = "Order",
  AutonomousAgent = "AutonomousAgent"
}
